(function () {
  'use strict';
  var root = document.querySelector('[data-lxc]');
  if (!root || root.__lxc) return; root.__lxc = true;
  var sectionId = root.getAttribute('data-section-id');
  var timer = null, busy = false;

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function render() {
    var url = (root.getAttribute('data-section-url') || location.pathname) + '?sections=' + encodeURIComponent(sectionId);
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j[sectionId]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-lxc-root]'), cur = root.querySelector('[data-lxc-root]');
      if (next && cur) cur.innerHTML = next.innerHTML;
      bind();
    });
  }
  function announce(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));
    var c = document.querySelector('[data-lxh-count]');
    if (c) { c.textContent = cart.item_count; c.hidden = !(cart.item_count > 0); }
  }
  function showError(msg) { var e = root.querySelector('[data-lxc-error]'); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; }
  function change(key, qty) {
    if (busy) return; busy = true; root.classList.add('is-loading'); showError('');
    post('/cart/change.js', { id: key, quantity: qty })
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (line && line.quantity !== qty && qty > 0) showError('Sorry, only ' + line.quantity + ' of this item can be added.');
        announce(cart); return render();
      })
      .catch(function (e) { showError((e && (e.description || e.message)) || 'Could not update your cart. Please try again.'); })
      .then(function () { busy = false; root.classList.remove('is-loading'); });
  }
  function bind() {
    root.querySelectorAll('[data-lxc-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-lxc-input]'), key = input.getAttribute('data-key');
      wrap.querySelector('[data-lxc-dec]').addEventListener('click', function () { change(key, Math.max(0, (parseInt(input.value, 10) || 1) - 1)); });
      wrap.querySelector('[data-lxc-inc]').addEventListener('click', function () { change(key, (parseInt(input.value, 10) || 0) + 1); });
      input.addEventListener('change', function () { clearTimeout(timer); var v = Math.max(0, parseInt(input.value, 10) || 0); timer = setTimeout(function () { change(key, v); }, 250); });
    });
    root.querySelectorAll('[data-lxc-remove]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); change(a.getAttribute('data-key'), 0); });
    });
    var note = root.querySelector('[data-lxc-note]');
    if (note) note.addEventListener('change', function () { post('/cart/update.js', { note: note.value }).catch(function () {}); });
    var form = root.querySelector('.lxc__form');
    if (form) form.addEventListener('submit', function (e) {
      /* never disable the submitter: a disabled button is not submitted and Shopify would not receive "checkout" */
      var b = e.submitter;
      if (b && b.name === 'checkout') {
        if (form.__sending) { e.preventDefault(); return; }
        form.__sending = true; b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
      }
    });
  }
  bind();
  window.addEventListener('pageshow', function (e) { if (e.persisted) render(); });
})();
